import { useMemo, useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viCheck, viLocationPinDot, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddMemberItem({ member, queue, setQueue }) {
  const [pending, setPending] = useState(false);

  const isActive = useMemo(
    () => !!queue.members.find((_member) => _member.exten === member.attributes.exten),
    [queue.members, member.attributes.exten],
  );

  function toggleMember() {
    setPending(true);

    if (isActive) {
      Promise.resolve(Api.deleteQueueMember(queue, member.attributes))
        .then(() =>
          setQueue((prevQueue) => ({
            ...prevQueue,
            members: prevQueue.members.filter((_member) => _member.exten !== member.attributes.exten),
          })),
        )
        .finally(() => setPending(false));
    } else {
      Promise.resolve(Api.postQueueMember(queue, member.attributes, "unlock"))
        .then((response) =>
          setQueue((prevQueue) => ({
            ...prevQueue,
            members: [
              ...prevQueue.members,
              { exten: member.attributes.exten, paused: null, state: 0, uniqueid: response.data.queueMember.uniqueid },
            ],
          })),
        )
        .finally(() => setPending(false));
    }
  }

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton onClick={toggleMember} disabled={pending} sx={{ minHeight: 44 }}>
        <ListItemAvatar>
          <Avatar text={member.attributes.name} icon={member.type === "user" ? undefined : viLocationPinDot} />
        </ListItemAvatar>
        <ListItemText primary={member.attributes.name} secondary={member.attributes.exten} />
        {(pending || isActive) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddMemberItem.propTypes = {
  member: PropTypes.object,
  queue: PropTypes.object,
  setQueue: PropTypes.func,
};

export default AddMemberItem;
